// Equipment names, shared by "New plan" and the customer page so both inputs behave the same.
export const EQUIPMENT_OPTIONS = ["Jupiter", "T20", "T30", "Mars", "N5", "Base and Rover Set"];
export const EQUIPMENT_MAX_LENGTH = 40;
export const UNSPECIFIED_EQUIPMENT = "(unspecified \u2014 needs review)";

export const isUnspecifiedName = (name) => {
  const n = String(name ?? "").trim();
  return n === "" || n === UNSPECIFIED_EQUIPMENT;
};

// Letters, digits and single spaces only. While typing (final = false) one trailing
// space is kept so multi-word names can be typed; on blur / next / submit (final = true)
// the edges are trimmed too.
export function sanitizeEquipmentName(raw, { final = false } = {}) {
  const cleaned = String(raw ?? "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // drop accents
    .replace(/[^A-Za-z0-9\s]/g, "") // drop symbols and invisible characters
    .replace(/\s+/g, " ") // tabs / newlines / repeated spaces -> one space
    .replace(/^ /, "") // no leading space
    .slice(0, EQUIPMENT_MAX_LENGTH);
  return final ? cleaned.trim() : cleaned;
}

// "t20" -> "T20", "base and rover set" -> "Base and Rover Set"; unknown names pass through.
export function canonicalEquipment(name) {
  const key = name.toLowerCase();
  return EQUIPMENT_OPTIONS.find((o) => o.toLowerCase() === key) || name;
}